import { Moment } from 'moment';
import { PlannerEventId } from '@/planner/models/ids';
import { UserId } from '@/shared/models/User';

export default class DossierWorkshopPlanning {
  eventId!: PlannerEventId;
  mechanicId!: UserId;
  paused!: boolean;
  start!: Moment;
  end!: Moment;
}
